<span class="relative inline-block" [class]="componentClass">
  <span class="sr-only"><ng-content></ng-content></span>
  <span class="relative animate-aurora" aria-hidden="true">
    <ng-content></ng-content>
  </span>
</span>
